import React, { useContext } from "react";
import { TimelineContext } from "src/components/Planner/Timeline/Timeline";
import { VirtuosoProps } from "react-virtuoso";
import { TimelineGroups } from "src/components/Planner/TimelineGroups";

const TimelineScroller: VirtuosoProps<unknown, unknown>['components']['Scroller'] = React.memo(React.forwardRef(({ style, ...props }, ref) => {
    const {
        data,
        timelineMode,
        positioning,
        totalWidth,
        onBarClick,
        onBarGroupClicked,
        onItemDurationChange,
        timelineDuration,
        timelineWidth,
        todayStyle,
        headerHeight,
        todayMs,
        columnDurations,
        onCategoryUpdated,
        onRailClicked,
        onGroupClicked,
        rights
    } = useContext(TimelineContext);

    return (
        <div
            className="TimelineScroller"
            style={{
                ...style,
            }}
            ref={ref} {...props}>
            {props.children}
            <div
                className="header-plate"
                style={{
                    height: headerHeight,
                    width: timelineWidth,
                }} />
            <TimelineGroups
                axisWidth={0}
                totalWidth={totalWidth}
                groups={data}
                columnDurations={columnDurations}
                onBarClick={onBarClick}
                onBarGroupClick={onBarGroupClicked}
                onCategoryUpdate={onCategoryUpdated}
                onRailClick={onRailClicked}
                onGroupClick={onGroupClicked}
                onItemDurationChange={onItemDurationChange}
                timelineDuration={timelineDuration}
                timelineMode={timelineMode}
                timelineSize={timelineWidth}
                todayTime={todayMs}
                positioning={positioning}
                headerHeight={headerHeight}
                rights={rights}
            />
            <div className="TimelineOverlay-today" style={todayStyle}>
                <div className="TimelineOverlay-todayLine">
                    <span
                        className="TimelineOverlay-todayArrow"
                        style={{
                            top: headerHeight
                        }}
                    />
                </div>
            </div>
        </div>
    )
}));

export default TimelineScroller;
